// Frontend-Feature-Toggle-Helper.
// Liest Boolean-Settings aus public.app_settings mit In-Memory-Cache (30 s).
// Fail-open: bei Fehler Fallback true.

import { supabase } from "@/integrations/supabase/client";

type CacheEntry = { value: boolean; expiresAt: number };
const CACHE = new Map<string, CacheEntry>();
const TTL_MS = 30_000;

async function readBool(key: string, fallback: boolean): Promise<boolean> {
  const now = Date.now();
  const cached = CACHE.get(key);
  if (cached && cached.expiresAt > now) return cached.value;
  try {
    const { data, error } = await supabase
      .from("app_settings")
      .select("value")
      .eq("key", key)
      .maybeSingle();
    if (error) throw error;
    let v = fallback;
    if (data && typeof data.value !== "undefined" && data.value !== null) {
      v = data.value === true || data.value === "true" || data.value === 1;
    }
    CACHE.set(key, { value: v, expiresAt: now + TTL_MS });
    return v;
  } catch (e) {
    console.warn(`[app-settings] read failed for ${key}:`, e);
    return fallback;
  }
}

export async function isOmnisendEnabled(): Promise<boolean> {
  return readBool("omnisend_enabled", true);
}

export function clearAppSettingsCache() {
  CACHE.clear();
}